import { Link2 } from 'lucide-react';

const STAGE_NAMES = { discover: 'Discover', define: 'Define', design: 'Design' };

export const LinkedNotice = ({ link, onAction }) => {
  const from = STAGE_NAMES[link.from.split('.')[0]];
  if (link.needs_review) {
    return (
      <div className="mt-3 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm" data-testid="linked-review-notice">
        <p className="text-amber-900">Your {from} answer changed since you customized this. Update it?</p>
        <p className="mt-1 text-amber-900/70 italic line-clamp-3">&ldquo;{String(link.upstream_value ?? '')}&rdquo;</p>
        <div className="mt-2 flex flex-wrap gap-3">
          <button onClick={() => onAction('use_updated')} className="text-[11px] uppercase tracking-[0.16em] underline" data-testid="linked-use-updated-button">Use updated answer</button>
          <button onClick={() => onAction('keep_mine')} className="text-[11px] uppercase tracking-[0.16em] underline" data-testid="linked-keep-mine-button">Keep mine</button>
        </div>
      </div>
    );
  }
  if (!link.customized && !link.confirmed && link.upstream_value !== null && link.upstream_value !== undefined && link.upstream_value !== '') {
    return (
      <div className="mt-3 flex flex-wrap items-center gap-3 rounded-xl border border-gold/40 bg-gold/5 px-4 py-2.5 text-sm" data-testid="linked-confirm-notice">
        <span className="inline-flex items-center gap-1.5 text-matte/80"><Link2 size={12} className="text-gold" /> Carried forward from {from}. Confirm it still fits, or edit it below.</span>
        <button onClick={() => onAction('confirm')} className="text-[11px] uppercase tracking-[0.16em] underline text-matte" data-testid="linked-confirm-button">Confirm</button>
      </div>
    );
  }
  return (
    <p className="mt-2 inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.16em] text-gold" data-testid="linked-chip">
      <Link2 size={11} /> {link.customized ? `Customized from ${from}` : link.confirmed ? `Confirmed from ${from}` : `Will fill in from ${from}`}
    </p>
  );
};
